import React from "react";


import { animateScroll as scroll } from "react-scroll";
import { ArrowToTop, ContactHeader, ContactLink, Copyright, FooterArrowLine, FooterBigLink, FooterBigLinkContainer, FooterContact, FooterContacts, FooterLine, FooterSmallTitle, FooterSmallTitleWrapper, FooterSocials, Small, StyledFooter } from "./footer.style";

const toTop = () => {
  scroll.scrollToTop({ delay: 0, duration: 0 });
};

const Footer = () => {
  const year = new Date().getFullYear();


  
        
  return (
    <StyledFooter>
      <FooterSmallTitleWrapper>
        <FooterSmallTitle>get in touch</FooterSmallTitle>
      </FooterSmallTitleWrapper>

      <FooterBigLinkContainer>
        <FooterBigLink
          href="mailto:anamhossain102@gmail.com"
          data-hover="Let's talk!"
        >
          Need a developer?
        </FooterBigLink>
      </FooterBigLinkContainer>
      <FooterContacts>
        <FooterContact>
          <ContactHeader>Call me</ContactHeader>
          <ContactLink href="tel:+8801818517949">+8801818517949</ContactLink>
        </FooterContact>
        <FooterContact>
          <ContactHeader>Social</ContactHeader>{" "}
          <FooterSocials>
            <ContactLink
              href="https://github.com/Enamhossain"
              target="_blank"
              rel="noopener noreferrer"
            >
              GitHub
            </ContactLink>
            <ContactLink
              href="https://www.linkedin.com/in/webenamhossain"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn
            </ContactLink>
            <ContactLink
              href="https://twitter.com/webenamhossain"
              target="_blank"
              rel="noopener noreferrer"
            >
             Twitter
            </ContactLink>
          </FooterSocials>
        </FooterContact>
        <FooterContact>
          <ContactHeader>Let's grab a coffee.</ContactHeader>
          <ContactLink href="tel:+639951076206">
            anamhossain102@gmail.com
          </ContactLink>
        </FooterContact>
      </FooterContacts>

      <FooterArrowLine>
        <FooterLine />
        <ArrowToTop title="Back to Top" onClick={toTop}  > </ArrowToTop>
      </FooterArrowLine>

      <Copyright>
        <small>
          &copy; Copyright {year},{" "}
          <Small
            href="https://github.com/webenamhossain"
            target="_blank"
            rel="noopener noreferrer"
          >
            Mohammad Enam Hossain
          </Small>
        </small>
      </Copyright>
    </StyledFooter>
  );
};

export default Footer;